const E = {
    MultiDeleteRecordsConfirmation: 'Are you sure you want to delete the selected records',
    MultiDelete: 'Multi Delete',
}

const F = {
    MultiDeleteRecordsConfirmation: 'Êtes-vous sûr de vouloir supprimer les enregistrements sélectionnés',
    MultiDelete: 'Supprimer multiple',
}


export default { E, F }


// WEBPACK FOOTER //
// ./src/constants/translations/multiDeletion.js